import { withNamespaces } from 'react-i18next'
import i18n from '../../../i18n'
import styles from './ShoppingCartDates.scss'

const ShoppingCartDates = ({ startDate, endDate, nights, t }) => {
    const renderDate = date => {
        return date.toLocaleString(i18n.language, {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timezone: 'UTC'
        })
    }

    return (
        <div>
            <p>
                {t('ShoppingCartDates.arrival')}
                <b class={styles.dateValue}>{renderDate(startDate)}</b>
            </p>
            <p>
                {t('ShoppingCartDates.departure')}
                <b class={styles.dateValue}>{renderDate(endDate)}</b>
            </p>
            <p>
                {t('ShoppingCartDates.nights')}
                <b>{nights}</b>
            </p>
        </div>
    )
}

export default withNamespaces()(ShoppingCartDates)



// WEBPACK FOOTER //
// ./components/ShoppingCart/ShoppingCartDates/ShoppingCartDates.js